import Vue from 'vue';
import Vuex from 'vuex';
import notification from './modules/notification';
import student from './modules/student';
import housing from './modules/housing';
import company from './modules/company';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cursus: [],
  },
  mutations: {
    SET_CURSUS(state, data) {
      state.cursus = data;
    },
  },
  actions: {
  },
  modules: {
    notification,
    student,
    housing,
    company,
  },
});
